import React from 'react';
import styles from './TermsAndConditions.module.css';

const BracketLink = () => (
  <a href="https://insomniacookies.com/bracket" target="_blank" rel="noopener noreferrer">
    insomniacookies.com/bracket
  </a>
);

/**
 * Static Official Rules for Snack Madness Sweepstakes (same layout as cookielab terms via module CSS).
 * Placeholder markers like [CB1.1] from source doc are omitted.
 */
export default function SnackMadnessTermsContent() {
  return (
    <div className={`${styles.pageContainer} text-dark dark:text-white`} data-part="content-surface">
      <div className={styles.pageSection} data-part="prose-section">
        <h1>SNACK MADNESS SWEEPSTAKES</h1>
        <p>Official Rules</p>
        <p>
          NO PURCHASE IS NECESSARY TO ENTER OR WIN. A PURCHASE WILL NOT INCREASE YOUR CHANCES OF WINNING. ALL
          FEDERAL, STATE, LOCAL, AND MUNICIPAL LAWS AND REGULATIONS APPLY. VOID WHERE PROHIBITED.
        </p>
      </div>

      <div className={styles.pageSection} data-part="prose-section">
        <h3>1. Sponsor</h3>
        <p>
          The Sweepstakes is sponsored by Insomnia Cookies (“Sponsor”), located at One South Broad Street, Suite
          120, Philadelphia, PA 19107.
        </p>
      </div>

      <div className={styles.pageSection} data-part="prose-section">
        <h3>2. Eligibility</h3>
        <p>
          The Snack Madness Sweepstakes (the “Sweepstakes”) is open to legal residents of the fifty (50) United
          States and the District of Columbia who are at least eighteen (18) years old at the time of entry.
          Employees of Sponsor and other companies associated with the promotion of the Sweepstakes, and their
          respective parents, subsidiaries, affiliates, and advertising and promotion agencies as well as the
          immediate family (spouse, parents, siblings, and children) and household members of their respective
          employees are not eligible. Prior to being eligible to receive any prize, an entrant who has been
          selected as a potential winner of the Sweepstakes must provide Sponsor with any information or
          certificates needed by Sponsor, in its judgment. Without limiting the foregoing, a person who was
          selected as a winner of the Sweepstakes may be required to complete and electronically sign 1) an
          affidavit of eligibility and 2) any other document Sponsor determines is required, necessary, or
          appropriate, in its judgment, to confirm the winner’s eligibility and for tax reporting purposes.
        </p>
        <p>
          Being eligible to participate in the Sweepstakes or receive a prize is contingent upon compliance with
          these Official Rules.
        </p>
      </div>

      <div className={styles.pageSection} data-part="prose-section">
        <h3>3. Agreement to Official Rules</h3>
        <p>
          Participation in the Sweepstakes constitutes the entrant’s full and unconditional agreement to and
          acceptance of these Official Rules and the decisions of Sponsor, which are final and binding. Winning
          a prize is contingent upon being compliant with these Official Rules and fulfilling all other
          requirements set forth herein.
        </p>
      </div>

      <div className={styles.pageSection} data-part="prose-section">
        <h3>4. Sweepstakes Period</h3>
        <p>
          The Sweepstakes begins on March 15, 2026 at 12:00 A.M. Eastern Time (“ET”) and ending on March 29, 2026
          at 11:59:59 P.M. ET (the &quot;Sweepstakes Period&quot;). Entries received from any person, or e-mail
          address, in excess of the stated limitation will be void. Entries that are submitted before or after the
          Sweepstakes Period will be disqualified. Submissions will be accepted for the duration of the
          Sweepstakes Period by visiting our website: 
          {' '}
          <BracketLink />
          . All entries become the property of Sponsor and will not be acknowledged or returned.
        </p>
      </div>

      <div className={styles.pageSection} data-part="prose-section">
        <h3>5. How to Enter</h3>
        <p>
          <strong>Basic Requirements:</strong>
          {' '}
To enter the Sweepstakes, an entrant must (i) have or create an
          Insomnia Rewards account and (ii) during the Sweepstakes Period, visit the Sweepstakes Homepage:
          {' '}
          <BracketLink />
          . The entrant must enter the valid email address associated with his or her Insomnia Rewards account
          and submit the registration form as described on the Sweepstakes Homepage. Each entrant who successfully
          submits a completed entry form will automatically receive one (1) entry into the Sweepstakes. All
          potential winners are subject to verification before any prize will be awarded. The Sponsor is
          responsible for the functionality of the Sweepstakes. Insomnia Rewards membership is free and may be
          created without making a purchase.
        </p>
        <p>
          <strong>Limit:</strong>
          {' '}
Each person meeting the above eligibility requirements may submit an entry form
          only one (1) time during the Sweepstakes Period, thereby receiving one (1) entry into the Sweepstakes.
          Multiple entrants are not permitted to share the same email address. Any attempt by any entrant to
          obtain more than the stated number of entries by using multiple/different email addresses, identities,
          registrations and logins, or any other methods will void that entrant’s entries and that entrant may be
          disqualified. Use of any automated system to participate is prohibited and will result in
          disqualification. Sponsor is not responsible for lost, late, incomplete, invalid, unintelligible, or
          misdirected registrations, which will be disqualified. In the event of a dispute as to any registration,
          the Authorized Account Holder (as defined below) of the email address used to register will be deemed to
          be the entrant. The “Authorized Account Holder” is the natural person assigned an email address by an
          Internet access provider, online service provider, or other organization responsible for assigning email
          addresses for the domain associated with the submitted address. Potential winners may be required to show
          proof of being the Authorized Account Holder.
        </p>
      </div>

      <div className={styles.pageSection} data-part="prose-section">
        <h3>6. Prize Drawing</h3>
        <p>
          On or about March 30, 2026 the Sponsor will select two (2) potential winner(s) in a random,
          computer-generated drawing from among all eligible entries received during the Sweepstakes Period.
        </p>
        <p>
          The odds of being selected depend on the number of entries received. Sponsor will attempt to notify the
          potential winner(s) via email on or about the same day that such drawing occurred. If the potential
          winner(s) cannot be contacted within one (1) day after the date of the first attempt to contact him/her,
          Sponsor may select an alternate potential winner(s) in his/her place at random from the remaining
          non-winning, eligible entries.
        </p>
      </div>

      <div className={styles.pageSection} data-part="prose-section">
        <h3>7. Winner Notification</h3>
        <p>
          <strong>A)</strong>
          {' '}
Sponsor’s decisions as to the administration and operation of the Sweepstakes and the
          selection of potential winners are final and binding in all matters related to the Sweepstakes.
        </p>
        <p>
          <strong>B)</strong>
          {' '}
The potential winners will be notified by email. Each potential winner of the
          Sweepstakes must comply with the requirements set forth in the “Eligibility” section above. If the
          potential winner fails to comply with such requirements within 1 (one) day of the date of notice or
          attempted notice, or if a potential winner cannot be contacted, or if the prize is returned as
          undeliverable, the potential winner forfeits the prize. If the potential winner is at least eighteen (18)
          years old but still considered a minor in his/her jurisdiction of residence, Sponsor reserves the right to
          award the prize in the name of his/her parent or legal guardian, who may be required to electronically
          sign the affidavit of eligibility on the potential winner’s behalf and fulfill any other requirements
          imposed on winners as set forth herein. Potential winners must continue to comply with all terms and
          conditions of these Official Rules, and winning is contingent upon fulfilling all requirements. In the
          event that a potential winner is disqualified for any reason, Sponsor will award the applicable prize to
          an alternate winner by random drawing from among all remaining eligible entries. Only three (3)
          alternate drawings will be held, after which the prize will remain un-awarded. Prizes will be fulfilled
          approximately eight (8) to ten (10) business days after the winner’s acceptance of the prize.
        </p>
        <p>
          <strong>C)</strong>
          {' '}
ALL POTENTIAL WINNERS OF THE SWEEPSTAKES ARE SUBJECT TO FINAL VERIFICATION OF
          ELIGIBILITY BY SPONSOR, WHOSE DECISIONS ARE FINAL AND BINDING IN ALL MATTERS RELATED TO THE SWEEPSTAKES.
          AN ENTRANT IS NOT A WINNER OF THE SWEEPSTAKES, OR PRIZE, EVEN IF THE SWEEPSTAKES SHOULD SO INDICATE,
          UNLESS AND UNTIL THAT ENTRANT’S ELIGIBILITY HAS BEEN VERIFIED, THAT ENTRANT HAS COMPLETED ALL NECESSARY
          FORMS AND DOCUMENTS, AND THE POTENTIAL WINNER HAS BEEN NOTIFIED THAT VERIFICATION IS COMPLETE. SPONSOR
          WILL NOT ACCEPT SCREENSHOTS OR OTHER EVIDENCE OF WINNING IN LIEU OF ITS VALIDATION PROCESS.
        </p>
      </div>

      <div className={styles.pageSection} data-part="prose-section">
        <h3>8. Prizes</h3>
        <p>
          <strong>Two (2) Winners:</strong>
          {' '}
Each winner will receive the following prize package (the “Prize”):
        </p>
        <ul style={{ fontSize: '23px', lineHeight: '30px', fontFamily: 'Montserrat', marginTop: '1rem', paddingLeft: '1.5rem' }}>
          <li style={{ marginBottom: '1rem' }}>
            One (1) airline/travel stipend in the amount of seven hundred ($750), provided in the form of a check or
            electronic payment at Sponsor&apos;s discretion;
          </li>
          <li style={{ marginBottom: '1rem' }}>
            Two (2) Fan Experience packages inclusive of a 4-night stay in a downtown Indianapolis hotel, (2)
            tickets to both NCAA Men’s Final Four games on Saturday, 4/4 and (2) tickets to the NCAA Men’s
            Championship game on Monday, 4/6, and access to other fan events/services.
          </li>
          <li style={{ marginBottom: '1rem' }}>
            Two (2) Insomnia Cookies SWAG kits, each containing select branded apparel, accessories, and/or other
            seasonal items (specific contents determined by Sponsor in its sole discretion); and
          </li>
          <li style={{ marginBottom: '1rem' }}>
            Two (2) Insomnia Cookies gift cards, each valued at one hundred dollars ($100.00), redeemable at all
            participating Sponsor locations and on Sponsor&apos;s website or mobile application.
          </li>
        </ul>
        <p>
          The approximate retail value (&quot;ARV&quot;) of each Prize is [$13,500]. The total ARV of all prizes
          combined is [$27,000]. Tickets are subject to the terms and conditions of the applicable venue and event
          organizer. In the event that any Final Four game is cancelled, postponed, or relocated for any reason,
          Sponsor shall have no obligation to provide substitute tickets or any other compensation. Travel
          arrangements, including but not limited to airfare, ground transportation, lodging, meals, and incidentals,
          are the sole responsibility of the winner and must be arranged and paid for by the winner from the travel
          stipend. Any travel expenses exceeding the travel stipend amount are the sole responsibility of the winner.
        </p>
        <p>
          No substitution or transfer of any prize is permitted, except at the sole discretion of Sponsor who
          reserves the right to substitute a prize of equal or greater value in the event the prize (or a portion
          of the prize) is unavailable. Prizes and prize components may be substituted for any reason at the
          discretion of Sponsor. All federal, state, and local taxes are the sole responsibility of the Sweepstakes
          Winner. Each winner may be required to complete an IRS Form W-9 prior to receiving the Prize.
        </p>
        <p>
          This Sweepstakes is not sponsored, endorsed, administered by, or otherwise associated with the NCAA.
        </p>
      </div>

      <div className={styles.pageSection} data-part="prose-section">
        <h3>9. Publicity</h3>
        <p>
          Except as prohibited by law, participation in the Sweepstakes constitutes the winner’s consent to Sponsor’s
          and its agents’ use and publication, without further compensation, of the winner’s name, photograph,
          likeness, voice, opinions, biographical information, and details of winning for advertising, promotional,
          or regulatory purposes in any media, worldwide, without further payment or consideration.
        </p>
      </div>

      <div className={styles.pageSection} data-part="prose-section">
        <h3>10. General Conditions</h3>
        <p>
          In the event that the operation, security, or administration of the Sweepstakes is impaired in any way for
          any reason, including, but not limited to fraud, virus, bug, worm, unauthorized human intervention, or
          other technical problem, or in the event the Sweepstakes is unable to run as planned for any other
          reason, as determined by Sponsor in its sole discretion, Sponsor may, in its sole discretion, either (a)
          suspend the Sweepstakes to address the impairment and then resume the Sweepstakes in a manner that best
          conforms to the spirit of these Official Rules or (b) terminate the Sweepstakes and, in the event of
          termination, award the prizes at random from among the eligible, non-suspect entries received up to the
          time of the impairment. Sponsor reserves the right in its sole discretion to disqualify any individual
          it finds to be tampering with the entry process or the operation of the Sweepstakes or to be acting in
          violation of these Official Rules or in an unsportsmanlike or disruptive manner. Any attempt by any person
          to damage the Sweepstakes website or undermine the legitimate operation of the Sweepstakes may be a
          violation of criminal and civil law, and, should such an attempt be made, Sponsor reserves the right to
          seek damages (including attorney’s fees) and any other remedies from any such person to the fullest extent
          permitted by law. Failure by Sponsor to enforce any provision of these Official Rules shall not constitute
          a waiver of that provision.
        </p>
      </div>

      <div className={styles.pageSection} data-part="prose-section">
        <h3>11. Release and Limitations of Liability</h3>
        <p>
          By participating in the Sweepstakes, entrants agree to release and hold harmless Sponsor and its
          respective parents, subsidiaries, affiliates, advertising and promotion agencies, and other companies
          associated with the Sweepstakes, and each of their respective officers, directors, employees, shareholders,
          representatives, and agents (the “Released Parties”), from and against any claim or cause of action
          arising out of participation in the Sweepstakes or receipt or use of the prize (including any travel or
          activity related thereto), including, but not limited to: (a) any technical errors associated with the
          Sweepstakes, including lost, interrupted, or unavailable Internet Service Provider (ISP), network, server,
          wireless service provider, or other connections, availability or accessibility or miscommunications or
          failed computer, satellite, telephone, cellular tower, or cable transmissions, lines, or technical failure
          or jumbled, scrambled, delayed, or misdirected transmissions or computer hardware or software malfunctions,
          failures, or difficulties; (b) unauthorized human intervention in the Sweepstakes; (c) mechanical,
          network, electronic, computer, human, printing, or typographical errors; (d) any other errors or problems
          in connection with the Sweepstakes, including, without limitation, errors that may occur in the
          administration of the Sweepstakes, the announcement of the winner, the cancellation or postponement of the
          event; or (e) injury, death, losses, or damages of any kind to persons or property which may be caused,
          directly or indirectly, in whole or in part, from the entrant’s participation in the Sweepstakes or
          acceptance, receipt, or misuse of the prize (including any travel or activity related thereto). The
          entrant further agrees that in any cause of action, the Released Parties’ liability will be limited to the
          cost of entering and participating in the Sweepstakes, and in no event shall the entrant be entitled to
          receive attorney’s fees. Released Parties are also not responsible for any incorrect or inaccurate
          information, whether caused by site users, tampering, hacking, or any equipment or programming associated
          with or utilized in the Sweepstakes. The entrant waives the right to claim any damages whatsoever,
          including, but not limited to, punitive, consequential, direct, or indirect damages.
        </p>
      </div>

      <div className={styles.pageSection} data-part="prose-section">
        <h3>12. Disputes</h3>
        <p>
          Except where prohibited, each entrant agrees that any and all disputes, claims, and causes of action
          arising out of, or connected with, the Sweepstakes or any prize awarded shall be resolved individually,
          without resort to any form of class action, and exclusively by the appropriate court located in New York.
          All issues and questions concerning the construction, validity, interpretation, and enforceability of
          these Official Rules, entrants’ rights and obligations, or the rights and obligations of Sponsor in
          connection with the Sweepstakes shall be governed by, and construed in accordance with, the laws of New
          York, without giving effect to any choice of law or conflict of law rules that would cause the
          application of the laws of any jurisdiction other than New York.
        </p>
      </div>

      <div className={styles.pageSection} data-part="prose-section">
        <h3>13. Privacy</h3>
        <p>
          Information collected from entrants is subject to Sponsor’s privacy policy, located at
          {' '}
          <a href="https://insomniacookies.com/privacy-policy" target="_blank" rel="noopener noreferrer">
            https://insomniacookies.com/privacy-policy
          </a>
          .
        </p>
      </div>
    </div>
  );
}
